var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "spinner-overlay",
      style: { backgroundColor: !_vm.spinnerShown ? "#0000" : undefined },
    },
    [
      _c("app-delayed-progress", {
        model: {
          value: _vm.spinnerShown,
          callback: function ($$v) {
            _vm.spinnerShown = $$v
          },
          expression: "spinnerShown",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }